var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: _vm.stroke,
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _vm.gradient
        ? _c(
            "defs",
            [
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: _vm.gradientId,
                    gradientUnits: "userSpaceOnUse",
                    x1: "4.46",
                    y1: "21.33",
                    x2: "19.54",
                    y2: "2.67"
                  }
                },
                [
                  _c("stop", {
                    attrs: {
                      offset: "17.49%",
                      "stop-color": "var(--t-comment-ai-1, #ff3300)"
                    }
                  }),
                  _vm._v(" "),
                  _c("stop", {
                    attrs: {
                      offset: "47.04%",
                      "stop-color": "var(--t-comment-ai-2, #e5886d)"
                    }
                  }),
                  _vm._v(" "),
                  _c("stop", {
                    attrs: {
                      offset: "64.23%",
                      "stop-color": "var(--t-comment-ai-3, #8ed9e1)"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"
        }
      }),
      _vm._v(" "),
      _c("path", { attrs: { d: "M20 2v4" } }),
      _vm._v(" "),
      _c("path", { attrs: { d: "M22 4h-4" } }),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "4", cy: "20", r: "2" } })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }